<template>
  <li :class="isMobility ? 'agency mobility' : 'agency' ">
    <div class="agency__checkbox">
      <div class="agency-flex-container">
        <p class="agency__heading">
          {{ $t('components.booking.agency') }}
        </p>
        <shared-check-box
          v-show="isShowReturnInput"
          :alert="alertDrop.alert"
          color="yellow"
          @check="toggleCheckbox"
          :initial-value="oneWay"
        >
          <p class="agency__checkbox__copy">
            <!-- <svg>
                <use xlink:href="#icon-one-way-white"></use>
            </svg> -->
            {{ $t('components.booking.return') }}
          </p>
        </shared-check-box>
        <ul
          class="agency__inputs"
          :class="{'-single-input': !isShowReturnInput}"
        >
          <li>
            <booking-input
              :value="pickUp.value"
              :active="pickUp.active"
              :alert="pickUp.alert"
              :drop="false"
              :geolocation="true"
              @selected="selectedPickup"
              @focus="focusPickup"
              @blur="blurPickup"
            />
          </li>
          <li>
            <booking-input
              v-show="isShowReturnInput && oneWay"
              :value="drop.value"
              :active="oneWay"
              :alert="drop.alert"
              :click-svg="drop.clickSvg"
              :drop="true"
              @clearvalue="drop.value = ''"
              @selected="selectedDrop"
              @focus="focusDrop"
              @blur="blurDrop"
            />
          </li>
        </ul>
      </div>
    </div>

    <light-box
      :visible="lightboxVisible"
      @close="lightboxVisible = false"
    >
      <div
        class="booking__lightbox"
        @click="closeLightBox"
      >
        <h3>{{ $t('components.booking.lightbox.title') }}</h3>
        <p>{{ $t('components.booking.lightbox.copy') }}</p>
        <rent-button>
          {{ $t('components.booking.lightbox.button') }}
        </rent-button>
      </div>
    </light-box>
  </li>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SharedCheckBox from '../shared/inputs/SharedCheckBox'
import BookingInput from './BookingInput'
import RentButton from '../shared/RentButton'
import LightBox from '../shared/LightBox'

export default {
  name: 'BookingPickAgencies',
  props: {
    alertPickUp: {
      type: Boolean,
      required: true,
      default: false,
    },
    alertDrop: {
      type: Boolean,
      required: true,
      default: false,
    },
    isMobility: {
      type: Boolean,
      default: false,
    },
    checkActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      geolocation: false,
      placeholders: this.$t('components.booking.geolocation'),
      checkbox: {
        alert: false,
      },
      pickUp: {
        value: '',
        active: this.checkActive !== false,
        alert: false,
        clickSvg: true,
      },
      drop: {
        value: '',
        active: false,
        alert: false,
        clickSvg: false,
      },
      lightboxVisible: false,
    }
  },
  components: {
    SharedCheckBox,
    BookingInput,
    LightBox,
    RentButton,
  },

  computed: {
    ...mapState({
      degradedMode: (state) => state.degradedMode,
      pickUpcities: (state) => state.booking.pickUp.cities,
      oneWayAvailable: (state) => state.booking.oneWayAvailable,
      oneWay: (state) => state.booking.oneWay,
      pickUpBusiness: (state) => state.booking.pickUp.business,
      dropBusiness: (state) => state.booking.drop.business,
      dropCities: (state) => state.booking.drop.cities,
    }),
    ...mapGetters({
      datesAndBusinessReady: 'booking/datesAndBusinessReady',
    }),
    isShowReturnInput() {
      return !this.degradedMode && this.oneWayAvailable
    },

    pickUpBusinessLabel() {
      return this.pickUpBusiness?.label
    },
    dropBusinessLabel() {
      return this.dropBusiness?.label
    },

  },
  watch: {

    geolocation: {
      handler() {
        this.geolocation2()
      },
      immediate: true,
    },

    pickUpBusinessLabel: {
      immediate: true,
      handler() {
        this.udpatePickupInput(this.pickUpBusiness?.label)
      },
    },
    pickUpBusiness(val, oldValExisted) {
      if (oldValExisted || !val) {
        return
      }
      this.udpateDropInput(this.pickUpBusiness.label)
    },
    dropBusiness(val, oldValExisted) {
      if (oldValExisted || !val) {
        return
      }
      this.udpateDropInput(this.dropBusiness.label)
    },
    alertPickUp(val) {
      this.pickUp.alert = !!val
    },
    alertDrop(val) {
      this.drop.alert = !!val
    },
  },
  methods: {
    geolocation2() {
      /* eslint-disable */
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state === 'granted') {
          this.geolocation = true;
        } if (result.state === 'prompt') {
          this.geolocation = false;
        }
        // Don't do anything if the permission was denied.
      });
      /* eslint-enable */
    },
    selectedPickup(val) {
      this.$store.commit('booking/SET_PICKUP_BUSINESS', val)
      if (this.datesAndBusinessReady) {
        this.$store.dispatch('vehicles/GET_AND_SET_AVAILABILITY')
        this.$store.dispatch('vehicles/GET_PRICES')
      }
      // update value of the input
      this.udpatePickupInput(this.pickUpBusiness.label)
    },
    selectedDrop(val) {
      this.$store.commit('booking/SET_DROP_BUSINESS', val)
      // update value of the input
      this.udpateDropInput(this.dropBusiness.label)
    },
    toggleCheckbox(val) {
      this.$store.commit('booking/SET_ONEWAY', val)
    },
    udpatePickupInput(value) {
      this.pickUp.value = value
    },
    udpateDropInput(value) {
      this.drop.value = value
    },
    focusPickup(value) {
      this.pickUp.value = value || ''
    },
    focusDrop() {
      // if there is no pickUp business but user clicked on the input so show popup
      if (!this.pickUp.value) {
        this.togglePopin()
      }
    },
    blurPickup() {
      if (
        !this.pickUpBusiness
        || !this.pickUpBusiness.label
        || this.drop.value
      ) {
        return
      }

      if (this.pickUpBusiness && this.oneWay) {
        return
      }

      this.udpatePickupInput(this.pickUpBusiness.label)
    },
    /* eslint-disable */
    // TODO Please fix
    blurDrop() {
      return
      // if there is no drop business but user clicked on the input so show popup
      if (!this.drop.value) {
        this.togglePopin()
      }
    },
    /* eslint-enable */
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible
    },
    closeLightBox() {
      this.lightboxVisible = false
    },
  },
}
</script>

<style scoped lang="scss">

.agency {
  align-content: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;

  &__checkbox {
    // display: flex;
    // flex-direction: column;
    // justify-content: flex-start;
    margin: 0 10px 10px 0;

    & ::v-deep .checkbox {
      align-items: center;
      margin-bottom: 0.5rem;

      @include teq-breakpoint($large) {
        margin-bottom: 0;
      }
    }

    @include teq-breakpoint($wide) {
      align-items: flex-end;
      flex-direction: row;
      margin: 0 10px 15px 0;
      min-height: 28px;

      & ::v-deep .checkbox {
        align-items: inherit;
      }
    }

    li {
      display: flex;
      justify-content: flex-start;
      margin: 0 0 5px 0;
    }

    li p,
    p {
      @include font-size(16px);

      color: white;
      font-family: $f-graphie-book;
      line-height: 1.6rem;
      margin: 0;
    }

    &__copy {
      padding-left: 5px;
    }

    .agency__heading {
      margin: 0 0 1.5rem;
      order: 1;
      width: 100%;

      @include teq-breakpoint($medium) {
        margin: 0 1rem 1.3rem 0;
        order: 1;
        width: auto;
      }
    }
  }

  &__inputs {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;

    &.-single-input {
      justify-content: flex-start;
    }

    li {
      display: flex;
      margin: 0 0 10px 0;

      & + & {
        margin: 0;
      }
    }
  }
}

.booking {
  &__copy {
    padding-left: 15px;
  }

  &__lightbox {
    background-color: white;
    color: black;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    text-align: center;

    h3 {
      margin-bottom: 45px;
    }
  }

  button {
    align-self: center;
    margin-top: 20px;
    max-width: 200px;
  }
}

.agency__checkbox {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @include font-size(16px);
}

.agency-flex-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;

  @include teq-breakpoint($medium) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.mobility {
  li p,
  p {
    color: black;
    font-family: $f-graphie-book;
  }

  .agency__checkbox {
    display: flex;
    flex-direction: column;
    font-family: $f-graphie-book;
    width: 100%;

    @include teq-breakpoint($medium) {
      width: auto;
    }
  }

  .agency__inputs {
    display: block;
    min-width: 100%;
    order: 2;
    width: 100%;

    @include teq-breakpoint($medium) {
      order: 3;
    }
  }

  .checkbox {
    @include font-size(12px);

    order: 3;

    @include teq-breakpoint($medium) {
      justify-content: flex-end;
      order: 2;
    }

    p {
      @include font-size(12px);
    }
  }
}

</style>
